import type { AppNotification } from '@/types';

export const notifications: AppNotification[] = [
  {
    id: 'N-101',
    type: 'Video',
    title: 'Video Geldi',
    description: 'Mehmet Demir inşaat sonrası temizlik videosunu gönderdi.',
    time: '08:40',
    read: false,
    actionPath: '/teklif-talepleri',
  },
  {
    id: 'N-102',
    type: 'Tahsilat',
    title: 'Tahsilat Bekliyor',
    description: 'Fatma Şahin işinde 4.600 TL bakiye var.',
    time: '08:15',
    read: false,
    actionPath: '/tahsilatlar',
  },
  {
    id: 'N-103',
    type: 'Randevu',
    title: 'Randevu Yaklaşıyor',
    description: 'Ayşe Yılmaz — Villa temizliği 60 dakika sonra başlıyor.',
    time: '08:00',
    read: false,
    actionPath: '/bugunun-isleri',
  },
  {
    id: 'N-104',
    type: 'Teklif',
    title: 'Teklif Bekliyor',
    description: 'Mehmet Demir videosu geldi fakat teklif hazırlanmadı.',
    time: '07:45',
    read: false,
    actionPath: '/teklifler',
  },
  {
    id: 'N-105',
    type: 'Takip',
    title: 'Teklif Takibi',
    description: 'Selin Kaya teklifine 2 gündür cevap vermedi.',
    time: 'Dün 18:00',
    read: true,
    actionPath: '/takip',
  },
  {
    id: 'N-106',
    type: 'Talep',
    title: 'Yeni Talep',
    description: 'Zeynep Arslan yazlık ev temizliği talebi gönderdi.',
    time: 'Dün 11:05',
    read: true,
    actionPath: '/teklif-talepleri',
  },
];